import { IRecordFurtherEducationEditItem, RecordFurtherEducationEditItem } from "./recordFurtherEducationEditItem";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";

export interface IRecordFurtherEducationEdit {
    education: IRecordFurtherEducationEditItem;
    furtherEducationGroups: IIdTitle[];
}

export class RecordFurtherEducationEdit implements IRecordFurtherEducationEdit {
    education: RecordFurtherEducationEditItem;
    furtherEducationGroups: IdTitle[];

    constructor();
    constructor(obj: IRecordFurtherEducationEdit);
    constructor(obj?: any) {
        this.education = new RecordFurtherEducationEditItem(obj ? obj.education : null);
        this.furtherEducationGroups = Base.getTypedArray(obj ? obj.furtherEducationGroups : null, IdTitle);
    }
}